export const exitFullScreen = (() => {
  const names = ['exitFullscreen', 'mozCancelFullScreen', 'msExitFullscreen', 'webkitExitFullscreen'];
  return names.reduce((prev, curr) => (document[curr] ? curr : prev));
})();

export const requestFullScreen = (() => {
  const names = ['requestFullscreen', 'mozRequestFullScreen', 'msRequestFullscreen', 'webkitRequestFullscreen'];
  return names.reduce((prev, curr) => (document.documentElement[curr] ? curr : prev));
})();

export const fullScreenElement = (() => {
  const names = ['fullscreenElement', 'mozFullScreenElement', 'msFullscreenElement', 'webkitFullscreenElement'];
  return names.reduce((prev, curr) => (document[curr] !== undefined ? curr : prev));
})();



// WEBPACK FOOTER //
// ./src/common/video/utils/browserPrefixedMethods.js